import { FaTimes } from "react-icons/fa";

export default function BotsModal({
  isOpen,
  onClose,
  bots = [],
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-white w-full max-w-2xl rounded-lg p-6 max-h-[80vh] overflow-y-auto"
       onClick={(e) => e.stopPropagation()}>

        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-[#1B4748]">
            بات‌های این طرح
          </h3>
          <button onClick={onClose} className="text-red-500">
            <FaTimes />
          </button>
        </div>

        {bots.length === 0 && (
          <p className="text-gray-500 text-sm">
            باتی برای این طرح ثبت نشده
          </p>
        )}

        <ul className="space-y-6">
          {bots.map(bot => (
            <li
              key={bot.id}
              className="border rounded-lg p-4 border-[#a9dec4]"
            >
              <div className="flex justify-between items-center mb-2">
                <p className="font-semibold text-[#1B4748]">
                  {bot.username || "—"}@
                </p>

                <span
                  className={`text-xs px-2 py-1 rounded-full
                    ${bot.status === "accepted"
                      ? "bg-green-100 text-green-700"
                      : bot.status === "rejected"
                      ? "bg-red-100 text-red-700"
                      : "bg-gray-200 text-gray-600"}
                  `}
                >
                  {bot.status}
                </span>
              </div>

              {bot.orgName && (
                <p className="text-sm mb-1">
                  <strong>سازمان:</strong> {bot.orgName}
                </p>
              )}

              {bot.website && (
                <p className="text-sm mb-1 break-all">
                  <strong>سایت:</strong> {bot.website}
                </p>
              )}

              <p className="text-sm mb-2">
                <strong>کیف پول:</strong>{" "}
                {bot.wallet.toLocaleString("fa-IR")}
              </p>

              <div className="text-sm">
                <strong>پرامپت:</strong>
                <p className="mt-1 max-h-32 overflow-y-auto whitespace-pre-wrap text-gray-600 bg-white p-2 rounded border">
                  {bot.prompt}
                </p>
              </div>
            </li>
          ))}
        </ul>

      </div>
    </div>
  );
}
